import styled, { css } from "styled-components/";
import { Link as RouterLink } from "react-router";

const LinkStyles = css`
  color: ${({ theme }) => theme.colors.black};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Link = styled(RouterLink)`
  ${LinkStyles}
`;

export default Link;
